module.exports = "/_next/static/images/d1e079671cec0df7cc641d3953fc839a-oxxo-icon.svg.webp";